import BaseModelAPI from '../BaseModelAPI';

export default class ReportDailyProductionList extends BaseModelAPI {

	static entity = 'newreport2003list'
	static entityName = 'reportdailyproduction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
